import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TooltipOrToast } from "@faire/retailer-visitor-shared/components/TooltipOrToast/TooltipOrToast";
import { useIdvStatus } from "@faire/retailer-visitor-shared/hooks/idv/useIdvStatus";
import { canMessageBrand, getIdvTransparencyMessage, getUnverifiedRetailerTooltipLabels, showVerificationTooltip } from "@faire/retailer-visitor-shared/lib/messageBrandCTAUtils";
import { LazyContactBrandModal } from "@faire/retailer-visitor-shared/views/brand/ContactBrand/modal/index";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { trackEventOnClick } from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { ChatBubble } from "@faire/web--source/slate/icons/foundation/ChatBubble";
import { Information } from "@faire/web--source/slate/icons/foundation/Information";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerPortalProductPageMessageBrandClick } from "@faire/web-api--source/events/retailerPortal/click/productPageMessageBrand";
import { observer } from "mobx-react";
import React, { Suspense, useState } from "react";
var MessageBrandCTABase = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var hasPendingIdv = useIdvStatus().hasPendingIdv;
    var pendingIdv = hasPendingIdv === "yes";
    var _useState = _sliced_to_array(useState(false), 2), isModalOpen = _useState[0], setIsModalOpen = _useState[1];
    var toggleModal = function() {
        if (!isModalOpen) {
            trackRetailerPortalProductPageMessageBrandClick("true");
        }
        setIsModalOpen(!isModalOpen);
    };
    var brand = props.brand, productName = props.productName, showLargeButton = props.showLargeButton;
    var button = showLargeButton ? /*#__PURE__*/ _jsxs(Button, {
        variant: "secondary",
        onClick: toggleModal,
        disabled: !canMessageBrand(brand),
        children: [
            /*#__PURE__*/ _jsx(ChatBubble, {
                color: "inherit"
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "Q8Er73",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Message Brand"
                    }
                ]
            })
        ]
    }) : /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: toggleModal,
        disabled: !canMessageBrand(brand),
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "MOz7yv",
            defaultMessage: [
                {
                    type: 0,
                    value: "Message the Brand"
                }
            ]
        })
    });
    var modal = isModalOpen ? /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyContactBrandModal, {
            productName: productName,
            brand: brand,
            closeContactMakerModal: toggleModal
        })
    }) : null;
    var _getIdvTransparencyMessage = getIdvTransparencyMessage(strictLocalize, pendingIdv), messageLabel = _getIdvTransparencyMessage.messageLabel, action = _getIdvTransparencyMessage.action;
    if (showVerificationTooltip(brand)) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(TooltipOrToast, {
                position: props.isInFooter ? "top" : "bottom",
                pointerOffset: props.isInFooter ? -50 : 0,
                primary: true,
                targetNode: button,
                contents: [
                    {
                        body: messageLabel
                    }
                ],
                action: action == null ? null : /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    tertiaryColor: "inherit",
                    linkTo: action.link,
                    onClick: trackEventOnClick("brand-messenger-tooltip/idv_request/link"),
                    target: "_blank",
                    children: action.label
                })
            })
        });
    } else {
        var unverifiedTooltipLabels = getUnverifiedRetailerTooltipLabels(strictLocalize);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                button,
                showVerificationTooltip(brand) ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Tooltip, {
                            primary: true,
                            position: "bottom",
                            icon: /*#__PURE__*/ _jsx(Information, {
                                width: "12px",
                                height: "12px"
                            }),
                            contents: [
                                {
                                    title: unverifiedTooltipLabels.title,
                                    body: unverifiedTooltipLabels.message
                                }
                            ]
                        })
                    ]
                }) : null,
                modal
            ]
        });
    }
};
export var MessageBrandCTA = observer(MessageBrandCTABase);
